import type { ComputedRef } from 'vue'
import type { SectionBaseItem } from '~/models/Content/SectionBaseItem'
import type { ContentType } from '~/models/Content/ContentType'
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { Subtree } from '~/models/Content/Subtree'
import useContentApi from '~/api/contentApi'

type SectionContentTypes = ContentType.SectionStandalone
  | ContentType.SectionExpanded
  | ContentType.SectionBox

export default <T extends SectionBaseItem>(
  contentIds: ComputedRef<Array<number>>,
  contentTypes: Array<SectionContentTypes>
) => {
  const { findContents } = useContentApi()
  return useQuery({
    enabled: computed(() => contentIds.value.length > 0 && contentTypes.length > 0),
    queryKey: computed(() => ['home-sections', 'dont-invalidate-on-grade-change', ...contentIds.value, ...contentTypes]),
    queryFn: () => findContents<T>({
      subtreeCriterion: [Subtree.Content, Subtree.App],
      contentTypeCriterion: contentTypes,
      contentIdCriterion: contentIds.value,
      mainLocationCriterion: true,
    }, contentIds.value.length),
    select: sections => sections
      .toSorted((a, b) => contentIds.value.indexOf(a.contentId) - contentIds.value.indexOf(b.contentId)),
    staleTime: Infinity,
  })
}
